import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const Card = styled(Box)`
    display: block;
    width: 178px;
    height: 288px;
    margin-bottom: 20px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 308px;
        height: 428px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 317px;
        height: 538px;
        margin-bottom: 10px;
    }
`
export const FontImage = styled(Box)`
    width: 100%;
    height: 150px;
    background: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 250px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const Image = styled.img`
    width: 178px;
    height: 150px;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const InformationSection = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 92px;
    background: ${({ theme }) => theme.colors.primaryWhite};

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 132px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
        height: 142px;
    }
`
export const NameEmployed = styled(Box)`
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const NameTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.footerPrimary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const PositionEmployed = styled(Box)`
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const PositionTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 21px;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.footerPrimary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SocialCard = styled(Box)`
    display: flex;
    flex-direction: row;
    width: 70%;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 60%;
    }
`

export const BottonContent = styled.a`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    font-family: inherit;
    justify-content: center;
    color: ${({ theme }) => theme.colors.white};
    width: 100%;
    font-size: 14px;
    height: 46px;
    background: ${({ theme }) => theme.colors.footerPrimary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        font-size: 16px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
        height: 46px;
        font-size: 18px;
    }
`
